// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:479px){.content[data-v-5d8cf04b]{flex:0 1 auto;max-height:calc(100vh - 84px)}div>.bucket[data-v-5d8cf04b]:last-child{margin-bottom:64px}div.bucket[data-v-5d8cf04b]{padding:12px}}", ""]);
// Exports
module.exports = exports;
